import { ReactQueryKeysAccount } from "services/queryKeys";

import UserIcon from "assets/icons/UserIcon32.svg?react";
import DatabaseIcon from "assets/icons/workspace/Header/DatabaseHeader.svg?react";
import EngineIcon from "assets/icons/workspace/Header/EngineHeader.svg?react";
import SecurityIcon from "assets/icons/workspace/Header/SecurityHeader.svg?react";

import { DatabasesPanel } from "../LeftSidebar/DatabasesPanel/DatabasesPanel";
import { EnginesPanel } from "../LeftSidebar/EnginesPanel/EnginesPanel";
import RolesDirectory from "./Directories/directories/RolesDirectory/RolesDirectory";
import UsersDirectory from "./Directories/directories/UsersDirectory/UsersDirectory";
import { HeaderControls } from "./Directory/HeaderControls/HeaderControls";
import { LeftSidebarDirectory, LeftSidebarSection } from "./types";

export const SECTION_DIRECTORIES: Record<
  LeftSidebarSection,
  LeftSidebarDirectory[]
> = {
  [LeftSidebarSection.DATA]: [LeftSidebarDirectory.DATABASES],
  [LeftSidebarSection.COMPUTE]: [LeftSidebarDirectory.ENGINES],
  [LeftSidebarSection.SECURITY]: [
    LeftSidebarDirectory.USERS,
    LeftSidebarDirectory.ROLES,
    // LeftSidebarDirectory.LOCATIONS,
  ],
};

export const DIRECTORY_CONFIG: Record<
  LeftSidebarDirectory,
  {
    title: string;
    icon: React.ReactNode;
    controls: React.ReactNode;
    component: React.ComponentType<unknown>;
  }
> = {
  [LeftSidebarDirectory.DATABASES]: {
    title: "Databases",
    icon: <DatabaseIcon />,
    controls: (
      <HeaderControls
        refreshQueryKeys={[
          [ReactQueryKeysAccount.databasesNames],
          ["database-search-tree"],
        ]}
        createType="database"
      />
    ),
    component: DatabasesPanel,
  },
  [LeftSidebarDirectory.ENGINES]: {
    title: "Engines",
    icon: <EngineIcon />,
    controls: (
      <HeaderControls
        refreshQueryKeys={[[ReactQueryKeysAccount.workspaceEngines]]}
        createType="engine"
      />
    ),
    component: EnginesPanel,
  },
  [LeftSidebarDirectory.SCRIPTS]: {
    title: "Scripts",
    icon: <SecurityIcon />,
    controls: <HeaderControls />,
    component: DatabasesPanel,
  },
  [LeftSidebarDirectory.TEMP]: {
    title: "Temp",
    icon: <SecurityIcon />,
    controls: <HeaderControls />,
    component: DatabasesPanel,
  },
  [LeftSidebarDirectory.USERS]: {
    title: "Users",
    icon: <UserIcon />,
    controls: (
      <HeaderControls
        refreshQueryKeys={[[ReactQueryKeysAccount.users]]}
        createType="user"
      />
    ),
    component: UsersDirectory,
  },
  [LeftSidebarDirectory.ROLES]: {
    title: "Roles",
    icon: <SecurityIcon />,
    controls: (
      <HeaderControls
        refreshQueryKeys={[[ReactQueryKeysAccount.rbacRoles]]}
        createType="role"
      />
    ),
    component: RolesDirectory,
  },
  [LeftSidebarDirectory.LOCATIONS]: {
    title: "Locations",
    icon: <SecurityIcon />,
    controls: <HeaderControls />,
    component: DatabasesPanel,
  },
};
